import { CognitoUser, CognitoUserAttribute } from "amazon-cognito-identity-js";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { userPool } from "../authentication-api/AuthenticationAPI";
import { handleSecureAjaxError } from "@limitless/portal/utils/SecurePlatformAPIUtils";
const getUsername = email => {
  return email.replace("@", "#").toLowerCase();
};
export const signUpUser = user => {
  const log = pilog.getLogger("SignUpAPI signUpUser");
  log.debug("Creating new user ", user);
  return new Promise((resolve, reject) => {
    const attributeList = [];
    //must be string
    const thirdPartyEmailsAttribute = new CognitoUserAttribute({
      Name: "custom:rcvThirdPartyEmails",
      Value: "false"
    });
    //must be string
    const receiveEmailMarkettingAttribute = new CognitoUserAttribute({
      Name: "custom:rcvEmailMktg",
      Value: `${user.newsLetter}`
    });
    //must be string
    const shareNameAttribute = new CognitoUserAttribute({
      Name: "custom:shareNameEmail",
      Value: "true"
    });
    //must be number
    const termsAgreeDateAttribute = new CognitoUserAttribute({
      Name: "custom:termsAgreeDate",
      Value: new Date().getTime().toString()
    });
    const emailAttribute = new CognitoUserAttribute({
      Name: "email",
      Value: user.email.toLowerCase()
    });
    const countryAttribute = new CognitoUserAttribute({
      Name: "locale",
      Value: user.country.value
    });
    const firstNameAttribute = new CognitoUserAttribute({
      Name: "custom:firstName",
      Value: user.firstName.trim()
    });
    const lastNameAttribute = new CognitoUserAttribute({
      Name: "custom:lastName",
      Value: user.lastName.trim()
    });
    const provinceAttribute = new CognitoUserAttribute({
      Name: "custom:stateProvinceCode",
      Value: user.town.value
    });
    const groupHashAttribute = new CognitoUserAttribute({
      Name: "custom:targetGroupHash",
      Value: user.groupHash
    });
    attributeList.push(thirdPartyEmailsAttribute);
    attributeList.push(shareNameAttribute);
    attributeList.push(termsAgreeDateAttribute);
    attributeList.push(emailAttribute);
    attributeList.push(countryAttribute);
    attributeList.push(provinceAttribute);
    attributeList.push(firstNameAttribute);
    attributeList.push(lastNameAttribute);
    attributeList.push(groupHashAttribute);
    attributeList.push(receiveEmailMarkettingAttribute);
    userPool.signUp(getUsername(user.email), user.password, attributeList, null, (err, result) => {
      if (err) {
        handleSecureAjaxError(err, "SignUpAPI signUpUser");
        if (err.code !== "UsernameExistsException") {
          reject("Error during sign up, please contact Limitless");
        }
        if (err.code === "UsernameExistsException") {
          reject(err.code);
        } else {
          reject(err.message || "Unknown error");
        }
      } else {
        log.debug("SignUp result ", result);
        resolve();
      }
    });
  });
};
export const confirmSignUpRegistrationCode = (email, registrationCode) => {
  const log = pilog.getLogger("SignUpAPI confirmSignUpRegistrationCode");
  const username = getUsername(email);
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: userPool
    });
    cognitoUser.confirmRegistration(registrationCode, true, (err, result) => {
      if (err) {
        log.debug(err);
        handleSecureAjaxError(err, "SignUpAPI confirmSignUpRegistrationCode");
        reject(err.message);
      } else {
        log.debug("Registration result ", result);
        resolve();
      }
    });
  });
};
export const resendSignUpRegistrationCode = email => {
  const log = pilog.getLogger("SignUpAPI resendSignUpRegistrationCode");
  return new Promise((resolve, reject) => {
    const cognitoUser = new CognitoUser({
      Username: getUsername(email),
      Pool: userPool
    });
    cognitoUser.resendConfirmationCode((err, result) => {
      if (err) {
        handleSecureAjaxError(err, "SignUpAPI resendSignUpRegistrationCode");
        reject(err.message);
      } else {
        log.debug("Resend Code result ", result);
        resolve();
      }
    });
  });
};